import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";

import { useFeatureFlag } from "cortex/ui/src/hooks";
import { auth } from "cortex/ui/src/store/auth";

type SignOutResponse = { sso_logout_url?: string | null };

export default function Logout() {
  const isSsoLoginEnabled = useFeatureFlag("sso-login");

  useEffect(() => {
    const run = async (): Promise<void> => {
      // We do a synchronous logout that forces termination of all in-flight
      // requests. This is to avoid a race condition where a user can logout
      // before receiving / setting the auth token. While this solution is
      // not ideal, it prevents us from having to rewrite the auth / login
      // flow.
      auth.clearToken();

      const response = (await auth.signOut()) as SignOutResponse;
      if (response.sso_logout_url && isSsoLoginEnabled) {
        window.location.href = response.sso_logout_url;
        return;
      }

      window.location.reload();
    };

    void run();
  }, []);

  return <Redirect to="/login" />;
}
